import { useEffect, useRef, useState } from 'react';

import type { VisibleImages } from '../model/types';

export const useImageIntersectionObserver = (sliderRef: React.RefObject<HTMLDivElement>) => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const imageRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [visibleImages, setVisibleImages] = useState<VisibleImages>({});

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          const index = parseInt(entry.target.getAttribute('data-index') || '0', 10);
          setVisibleImages(prev => ({
            ...prev,
            [index]: entry.isIntersecting,
          }));
        });
      },
      {
        root: sliderRef.current,
        rootMargin: '50px',
        threshold: 0.1,
      },
    );

    imageRefs.current.forEach(ref => {
      if (ref) {
        observerRef.current?.observe(ref);
      }
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [sliderRef]);

  return {
    imageRefs,
    visibleImages,
  };
};
